import { ContentfulOrderProduct } from '@ravago/shared/page-data/models/contentful';

export async function getContentfulProductsByIds(locale: string, productIds: string[]): Promise<ContentfulOrderProduct[] | undefined> {
  const response = await fetch(`/api/orders/products?locale=${locale}&ids=${productIds.join(',')}`);
  const data = await response.json();
  return data;
}
